import * as React from 'react';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import Web3, {Bytes} from 'web3';
import {useRef, useState} from 'react';
import {
    CssBaseline,
    CssVarsProvider,
    GlobalStyles, IconButton,
    Modal, ModalClose,
    Sheet, Switch
} from '@mui/joy';
import {createStore, EIP6963ProviderDetail} from 'mipd'
import {SwapVert} from "@mui/icons-material";

let web3WalletsStore = createStore();
web3WalletsStore.subscribe(() => {
});

let web3: Web3 | null = null;
let web3InternalUnichain = new Web3('https://mainnet-readonly.unichain.org/')
let web3InternalL1 = new Web3('https://eth.meowrpc.com')

const ucornAddress = '0x0000000000c82e1318ebb48e7AbA43Be281A3B8d';
const ucornABI = [
    {
        'constant': true,
        'inputs': [],
        'name': 'name',
        'outputs': [
            {
                'name': '',
                'type': 'string'
            }
        ],
        'payable': false,
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'constant': false,
        'inputs': [
            {
                'name': '_spender',
                'type': 'address'
            },
            {
                'name': '_value',
                'type': 'uint256'
            }
        ],
        'name': 'approve',
        'outputs': [
            {
                'name': '',
                'type': 'bool'
            }
        ],
        'payable': false,
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'constant': true,
        'inputs': [],
        'name': 'totalSupply',
        'outputs': [
            {
                'name': '',
                'type': 'uint256'
            }
        ],
        'payable': false,
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'constant': false,
        'inputs': [
            {
                'name': '_from',
                'type': 'address'
            },
            {
                'name': '_to',
                'type': 'address'
            },
            {
                'name': '_value',
                'type': 'uint256'
            }
        ],
        'name': 'transferFrom',
        'outputs': [
            {
                'name': '',
                'type': 'bool'
            }
        ],
        'payable': false,
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'constant': true,
        'inputs': [],
        'name': 'decimals',
        'outputs': [
            {
                'name': '',
                'type': 'uint8'
            }
        ],
        'payable': false,
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'constant': true,
        'inputs': [
            {
                'name': '_owner',
                'type': 'address'
            }
        ],
        'name': 'balanceOf',
        'outputs': [
            {
                'name': 'balance',
                'type': 'uint256'
            }
        ],
        'payable': false,
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'constant': true,
        'inputs': [],
        'name': 'symbol',
        'outputs': [
            {
                'name': '',
                'type': 'string'
            }
        ],
        'payable': false,
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'constant': false,
        'inputs': [
            {
                'name': '_to',
                'type': 'address'
            },
            {
                'name': '_value',
                'type': 'uint256'
            }
        ],
        'name': 'transfer',
        'outputs': [
            {
                'name': '',
                'type': 'bool'
            }
        ],
        'payable': false,
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'constant': true,
        'inputs': [
            {
                'name': '_owner',
                'type': 'address'
            },
            {
                'name': '_spender',
                'type': 'address'
            }
        ],
        'name': 'allowance',
        'outputs': [
            {
                'name': '',
                'type': 'uint256'
            }
        ],
        'payable': false,
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'payable': true,
        'stateMutability': 'payable',
        'type': 'fallback'
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'name': 'owner',
                'type': 'address'
            },
            {
                'indexed': true,
                'name': 'spender',
                'type': 'address'
            },
            {
                'indexed': false,
                'name': 'value',
                'type': 'uint256'
            }
        ],
        'name': 'Approval',
        'type': 'event'
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'name': 'from',
                'type': 'address'
            },
            {
                'indexed': true,
                'name': 'to',
                'type': 'address'
            },
            {
                'indexed': false,
                'name': 'value',
                'type': 'uint256'
            }
        ],
        'name': 'Transfer',
        'type': 'event'
    }
];
const ucorn = new web3InternalUnichain.eth.Contract(ucornABI, ucornAddress);

const ucornRouterAddress = '0x0000000000EBCF4bAca7e81ca2d3ec09DF339c22'
const ucornRouterABI = [
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'amountIn',
                'type': 'uint256'
            },
            {
                'internalType': 'uint256',
                'name': 'amountOutMin',
                'type': 'uint256'
            },
            {
                'internalType': 'address',
                'name': 'recipient',
                'type': 'address'
            }
        ],
        'name': 'abandon',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'bool',
                'name': 'buy',
                'type': 'bool'
            },
            {
                'internalType': 'uint256',
                'name': 'amountIn',
                'type': 'uint256'
            }
        ],
        'name': 'quote',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'amountOutMin',
                'type': 'uint256'
            },
            {
                'internalType': 'address',
                'name': 'recipient',
                'type': 'address'
            }
        ],
        'name': 'ucorn',
        'outputs': [],
        'stateMutability': 'payable',
        'type': 'function'
    },
    {
        'stateMutability': 'nonpayable',
        'type': 'fallback'
    },
    {
        'inputs': [],
        'name': 'UCORN',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'UniswapV4PoolManager',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'Website',
        'outputs': [
            {
                'internalType': 'string',
                'name': '',
                'type': 'string'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    }
]
const ucornRouter = new web3InternalUnichain.eth.Contract(ucornRouterABI, ucornRouterAddress);

const bridgeAddress = '0x0bd48f6B86a26D3a217d0Fa6FfE2B491B956A7a2'
const bridgeABI = [
    {
        'inputs': [{
            'internalType': 'uint256',
            'name': '_proofMaturityDelaySeconds',
            'type': 'uint256'
        },
            {
                'internalType': 'uint256',
                'name': '_disputeGameFinalityDelaySeconds',
                'type': 'uint256'
            }],
        'stateMutability': 'nonpayable',
        'type': 'constructor'
    },
    {
        'inputs': [],
        'name': 'BadTarget',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'CallPaused',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'ContentLengthMismatch',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'EmptyItem',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'GasEstimation',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'InvalidDataRemainder',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'InvalidHeader',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'LargeCalldata',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'OutOfGas',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'SmallGasLimit',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'Unauthorized',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'UnexpectedList',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'UnexpectedString',
        'type': 'error'
    },
    {
        'anonymous': false,
        'inputs': [{
            'indexed': true,
            'internalType': 'contract IDisputeGame',
            'name': 'disputeGame',
            'type': 'address'
        }],
        'name': 'DisputeGameBlacklisted',
        'type': 'event'
    },
    {
        'anonymous': false,
        'inputs': [{
            'indexed': false,
            'internalType': 'uint8',
            'name': 'version',
            'type': 'uint8'
        }],
        'name': 'Initialized',
        'type': 'event'
    },
    {
        'anonymous': false,
        'inputs': [{
            'indexed': true,
            'internalType': 'GameType',
            'name': 'newGameType',
            'type': 'uint32'
        },
            {
                'indexed': true,
                'internalType': 'Timestamp',
                'name': 'updatedAt',
                'type': 'uint64'
            }],
        'name': 'RespectedGameTypeSet',
        'type': 'event'
    },
    {
        'anonymous': false,
        'inputs': [{
            'indexed': true,
            'internalType': 'address',
            'name': 'from',
            'type': 'address'
        },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'to',
                'type': 'address'
            },
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'version',
                'type': 'uint256'
            },
            {
                'indexed': false,
                'internalType': 'bytes',
                'name': 'opaqueData',
                'type': 'bytes'
            }],
        'name': 'TransactionDeposited',
        'type': 'event'
    },
    {
        'anonymous': false,
        'inputs': [{
            'indexed': true,
            'internalType': 'bytes32',
            'name': 'withdrawalHash',
            'type': 'bytes32'
        },
            {
                'indexed': false,
                'internalType': 'bool',
                'name': 'success',
                'type': 'bool'
            }],
        'name': 'WithdrawalFinalized',
        'type': 'event'
    },
    {
        'anonymous': false,
        'inputs': [{
            'indexed': true,
            'internalType': 'bytes32',
            'name': 'withdrawalHash',
            'type': 'bytes32'
        },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'from',
                'type': 'address'
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'to',
                'type': 'address'
            }],
        'name': 'WithdrawalProven',
        'type': 'event'
    },
    {
        'anonymous': false,
        'inputs': [{
            'indexed': true,
            'internalType': 'bytes32',
            'name': 'withdrawalHash',
            'type': 'bytes32'
        },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'proofSubmitter',
                'type': 'address'
            }],
        'name': 'WithdrawalProvenExtension1',
        'type': 'event'
    },
    {
        'inputs': [{
            'internalType': 'contract IDisputeGame',
            'name': '_disputeGame',
            'type': 'address'
        }],
        'name': 'blacklistDisputeGame',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [{
            'internalType': 'bytes32',
            'name': '_withdrawalHash',
            'type': 'bytes32'
        },
            {
                'internalType': 'address',
                'name': '_proofSubmitter',
                'type': 'address'
            }],
        'name': 'checkWithdrawal',
        'outputs': [],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [{
            'internalType': 'address',
            'name': '_to',
            'type': 'address'
        },
            {
                'internalType': 'uint256',
                'name': '_value',
                'type': 'uint256'
            },
            {
                'internalType': 'uint64',
                'name': '_gasLimit',
                'type': 'uint64'
            },
            {
                'internalType': 'bool',
                'name': '_isCreation',
                'type': 'bool'
            },
            {
                'internalType': 'bytes',
                'name': '_data',
                'type': 'bytes'
            }],
        'name': 'depositTransaction',
        'outputs': [],
        'stateMutability': 'payable',
        'type': 'function'
    },
    {
        'inputs': [{
            'internalType': 'contract IDisputeGame',
            'name': '',
            'type': 'address'
        }],
        'name': 'disputeGameBlacklist',
        'outputs': [{
            'internalType': 'bool',
            'name': '',
            'type': 'bool'
        }],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'disputeGameFactory',
        'outputs': [{
            'internalType': 'contract DisputeGameFactory',
            'name': '',
            'type': 'address'
        }],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'disputeGameFinalityDelaySeconds',
        'outputs': [{
            'internalType': 'uint256',
            'name': '',
            'type': 'uint256'
        }],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'donateETH',
        'outputs': [],
        'stateMutability': 'payable',
        'type': 'function'
    },
    {
        'inputs': [{
            'components': [{
                'internalType': 'uint256',
                'name': 'nonce',
                'type': 'uint256'
            },
                {
                    'internalType': 'address',
                    'name': 'sender',
                    'type': 'address'
                },
                {
                    'internalType': 'address',
                    'name': 'target',
                    'type': 'address'
                },
                {
                    'internalType': 'uint256',
                    'name': 'value',
                    'type': 'uint256'
                },
                {
                    'internalType': 'uint256',
                    'name': 'gasLimit',
                    'type': 'uint256'
                },
                {
                    'internalType': 'bytes',
                    'name': 'data',
                    'type': 'bytes'
                }],
            'internalType': 'struct Types.WithdrawalTransaction',
            'name': '_tx',
            'type': 'tuple'
        }],
        'name': 'finalizeWithdrawalTransaction',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [{
            'components': [{
                'internalType': 'uint256',
                'name': 'nonce',
                'type': 'uint256'
            },
                {
                    'internalType': 'address',
                    'name': 'sender',
                    'type': 'address'
                },
                {
                    'internalType': 'address',
                    'name': 'target',
                    'type': 'address'
                },
                {
                    'internalType': 'uint256',
                    'name': 'value',
                    'type': 'uint256'
                },
                {
                    'internalType': 'uint256',
                    'name': 'gasLimit',
                    'type': 'uint256'
                },
                {
                    'internalType': 'bytes',
                    'name': 'data',
                    'type': 'bytes'
                }],
            'internalType': 'struct Types.WithdrawalTransaction',
            'name': '_tx',
            'type': 'tuple'
        },
            {
                'internalType': 'address',
                'name': '_proofSubmitter',
                'type': 'address'
            }],
        'name': 'finalizeWithdrawalTransactionExternalProof',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [{
            'internalType': 'bytes32',
            'name': '',
            'type': 'bytes32'
        }],
        'name': 'finalizedWithdrawals',
        'outputs': [{
            'internalType': 'bool',
            'name': '',
            'type': 'bool'
        }],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'guardian',
        'outputs': [{
            'internalType': 'address',
            'name': '',
            'type': 'address'
        }],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [{
            'internalType': 'contract DisputeGameFactory',
            'name': '_disputeGameFactory',
            'type': 'address'
        },
            {
                'internalType': 'contract SystemConfig',
                'name': '_systemConfig',
                'type': 'address'
            },
            {
                'internalType': 'contract SuperchainConfig',
                'name': '_superchainConfig',
                'type': 'address'
            },
            {
                'internalType': 'GameType',
                'name': '_initialRespectedGameType',
                'type': 'uint32'
            }],
        'name': 'initialize',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'l2Sender',
        'outputs': [{
            'internalType': 'address',
            'name': '',
            'type': 'address'
        }],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [{
            'internalType': 'uint64',
            'name': '_byteCount',
            'type': 'uint64'
        }],
        'name': 'minimumGasLimit',
        'outputs': [{
            'internalType': 'uint64',
            'name': '',
            'type': 'uint64'
        }],
        'stateMutability': 'pure',
        'type': 'function'
    },
    {
        'inputs': [{
            'internalType': 'bytes32',
            'name': '_withdrawalHash',
            'type': 'bytes32'
        }],
        'name': 'numProofSubmitters',
        'outputs': [{
            'internalType': 'uint256',
            'name': '',
            'type': 'uint256'
        }],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'params',
        'outputs': [{
            'internalType': 'uint128',
            'name': 'prevBaseFee',
            'type': 'uint128'
        },
            {
                'internalType': 'uint64',
                'name': 'prevBoughtGas',
                'type': 'uint64'
            },
            {
                'internalType': 'uint64',
                'name': 'prevBlockNum',
                'type': 'uint64'
            }],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'paused',
        'outputs': [{
            'internalType': 'bool',
            'name': '',
            'type': 'bool'
        }],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'proofMaturityDelaySeconds',
        'outputs': [{
            'internalType': 'uint256',
            'name': '',
            'type': 'uint256'
        }],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [{
            'internalType': 'bytes32',
            'name': '',
            'type': 'bytes32'
        },
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256'
            }],
        'name': 'proofSubmitters',
        'outputs': [{
            'internalType': 'address',
            'name': '',
            'type': 'address'
        }],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [{
            'components': [{
                'internalType': 'uint256',
                'name': 'nonce',
                'type': 'uint256'
            },
                {
                    'internalType': 'address',
                    'name': 'sender',
                    'type': 'address'
                },
                {
                    'internalType': 'address',
                    'name': 'target',
                    'type': 'address'
                },
                {
                    'internalType': 'uint256',
                    'name': 'value',
                    'type': 'uint256'
                },
                {
                    'internalType': 'uint256',
                    'name': 'gasLimit',
                    'type': 'uint256'
                },
                {
                    'internalType': 'bytes',
                    'name': 'data',
                    'type': 'bytes'
                }],
            'internalType': 'struct Types.WithdrawalTransaction',
            'name': '_tx',
            'type': 'tuple'
        },
            {
                'internalType': 'uint256',
                'name': '_disputeGameIndex',
                'type': 'uint256'
            },
            {
                'components': [{
                    'internalType': 'bytes32',
                    'name': 'version',
                    'type': 'bytes32'
                },
                    {
                        'internalType': 'bytes32',
                        'name': 'stateRoot',
                        'type': 'bytes32'
                    },
                    {
                        'internalType': 'bytes32',
                        'name': 'messagePasserStorageRoot',
                        'type': 'bytes32'
                    },
                    {
                        'internalType': 'bytes32',
                        'name': 'latestBlockhash',
                        'type': 'bytes32'
                    }],
                'internalType': 'struct Types.OutputRootProof',
                'name': '_outputRootProof',
                'type': 'tuple'
            },
            {
                'internalType': 'bytes[]',
                'name': '_withdrawalProof',
                'type': 'bytes[]'
            }],
        'name': 'proveWithdrawalTransaction',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [{
            'internalType': 'bytes32',
            'name': '',
            'type': 'bytes32'
        },
            {
                'internalType': 'address',
                'name': '',
                'type': 'address'
            }],
        'name': 'provenWithdrawals',
        'outputs': [{
            'internalType': 'contract IDisputeGame',
            'name': 'disputeGameProxy',
            'type': 'address'
        },
            {
                'internalType': 'uint64',
                'name': 'timestamp',
                'type': 'uint64'
            }],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'respectedGameType',
        'outputs': [{
            'internalType': 'GameType',
            'name': '',
            'type': 'uint32'
        }],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'respectedGameTypeUpdatedAt',
        'outputs': [{
            'internalType': 'uint64',
            'name': '',
            'type': 'uint64'
        }],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [{
            'internalType': 'GameType',
            'name': '_gameType',
            'type': 'uint32'
        }],
        'name': 'setRespectedGameType',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'superchainConfig',
        'outputs': [{
            'internalType': 'contract SuperchainConfig',
            'name': '',
            'type': 'address'
        }],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'systemConfig',
        'outputs': [{
            'internalType': 'contract SystemConfig',
            'name': '',
            'type': 'address'
        }],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'version',
        'outputs': [{
            'internalType': 'string',
            'name': '',
            'type': 'string'
        }],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'stateMutability': 'payable',
        'type': 'receive'
    }]
const bridge = new web3InternalL1.eth.Contract(bridgeABI, bridgeAddress);

export default function UCORN() {
    React.useEffect(() => {
        let web3Wallets: EIP6963ProviderDetail[] = web3WalletsStore.getProviders().slice();
        if (web3Wallets.length === 0) {
            setButtonDisabled(true);
            setButtonContent('No Web3 Wallet Installed');
            return;
        }

        let metaMask = web3WalletsStore.findProvider({rdns: 'io.metamask'});
        metaMask ? web3 = new Web3(metaMask.provider) : web3 = new Web3(web3Wallets[0].provider);
        handleUpdate().then();

        if (web3?.currentProvider) {
            web3?.currentProvider.on('accountsChanged', handleUpdate);
            web3?.currentProvider.on('chainChanged', handleUpdate);
        }
        return () => {
            if (web3?.currentProvider) {
                web3?.currentProvider.removeListener('accountsChanged', handleUpdate);
                web3?.currentProvider.removeListener('chainChanged', handleUpdate);
            }
        };
    }, [])

    const [accountETHBalance, setAccountETHBalance] = React.useState('');
    const [accountUCORNBalance, setAccountUCORNBalance] = React.useState('');

    const [showSwitchNetwork, setShowSwitchNetwork] = React.useState(false);

    const [buttonContent, setButtonContent] = useState('Connect Wallet');
    const [buttonLoading, setButtonLoading] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);

    const [ethInput, setETHInput] = useState('');
    const [ethInputDisabled, setETHInputDisabled] = useState(false);

    const [ucornInput, setUCORNInput] = useState('');
    const [ucornInputDisabled, setUCORNInputDisabled] = useState(true);

    const [isBuying, setIsBuying] = React.useState(true);
    const [onL1, setOnL1] = React.useState(false);
    const [useUnichainETH, setUseUnichainETH] = React.useState(false);

    const [modalOpen, setModalOpen] = React.useState(false);
    const [modalTitle, setModalTitle] = React.useState('');
    const [modalContent, setModalContent] = React.useState('');

    async function handleSetIsSelling() {
        setIsBuying(!isBuying);

        setETHInput('');
        setETHInputDisabled(!ethInputDisabled);

        setUCORNInput('');
        setUCORNInputDisabled(!ucornInputDisabled);
    }

    async function switchToL1() {
        if (!web3 || !web3.provider) return;

        try {
            await web3.provider.request({
                method: "wallet_switchEthereumChain",
                params: [{chainId: '0x1'}],
            });
        } catch (e) {
            await web3.provider.request({
                method: "wallet_addEthereumChain",
                params: [
                    {
                        chainId: "0x1",
                        chainName: "Ethereum Mainnet",
                        rpcUrls: ["https://eth.llamarpc.com"],
                        blockExplorerUrls: ["https://etherscan.io"],
                        nativeCurrency: {
                            name: "ETH",
                            symbol: "ETH",
                            decimals: 18,
                        },
                    },
                ],
            });
        }
    }

    async function switchToUnichain() {
        if (!web3 || !web3.provider) return;

        try {
            await web3.provider.request({
                method: "wallet_switchEthereumChain",
                params: [{chainId: '0x82'}],
            });
        } catch (e) {
            await web3.provider.request({
                method: "wallet_addEthereumChain",
                params: [
                    {
                        chainId: "0x82",
                        chainName: "Unichain Mainnet",
                        rpcUrls: ["https://unichainrpc.chaineye.tools"],
                        blockExplorerUrls: ["https://unichainexplorer.chaineye.tools"],
                        nativeCurrency: {
                            name: "ETH",
                            symbol: "ETH",
                            decimals: 18,
                        },
                    },
                ],
            });
        }
    }

    async function handleUpdate() {
        if (!web3) return;

        setETHInput('');
        setUCORNInput('');
        setButtonDisabled(true);

        let chainID = await web3?.eth.getChainId();
        if (chainID !== web3?.utils.toBigInt(130) && chainID !== web3?.utils.toBigInt(1)) {
            setAccountETHBalance('');
            setAccountUCORNBalance('');
            setShowSwitchNetwork(true);
            return;
        }
        setShowSwitchNetwork(false);
        setOnL1(chainID === web3?.utils.toBigInt(1));

        let accounts = await web3.eth.getAccounts()
        if (accounts.length) {
            await web3.eth.getChainId() === web3.utils.toBigInt(130) ? setButtonContent('Swap on Unichain') : setButtonContent('Swap from L1');

            setAccountETHBalance('Balance: Loading...')
            setAccountUCORNBalance('Balance: Loading...')

            let ethBalance;
            let ucornBalance;
            try {
                ethBalance = web3.utils.fromWei(await web3.eth.getBalance(accounts[0]), 'ether');
                ucornBalance = Web3.utils.fromWei(await ucorn.methods.balanceOf(accounts[0]).call(), 'ether');
            } catch (e) {
            }
            if (ethBalance) {
                let decimalIndex = ethBalance.indexOf('.');
                if (decimalIndex !== -1) {
                    ethBalance = ethBalance.substring(0, decimalIndex + 7);
                }
            } else {
                ethBalance = 'ERROR';
            }
            if (ucornBalance) {
                let decimalIndex = ucornBalance.indexOf('.');
                if (decimalIndex !== -1) {
                    ucornBalance = ucornBalance.substring(0, decimalIndex);
                }
            } else {
                ucornBalance = 'ERROR';
            }

            setAccountETHBalance('Balance: ' + ethBalance);
            setAccountUCORNBalance('Balance: ' + ucornBalance);
        } else {
            setAccountETHBalance('');
            setAccountUCORNBalance('');
            setButtonContent('Connect Wallet');
            setButtonDisabled(false);
        }
    }

    let inputTimeoutRef = useRef<ReturnType<typeof setTimeout> | -1>(-1);

    async function onETHInputChange(value: string) {
        if (value === '') {
            setETHInput('');
            setUCORNInput('');
            setButtonDisabled(true);
            return;
        }

        const inputRegex = /^[0-9]+(\.[0-9]*)?$/;
        if (inputRegex.test(value)) setETHInput(value);

        const quoteRegex = /^[0-9]+(\.[0-9]+)?$/;
        if (quoteRegex.test(value)) {
            let parsedETHInput: string = Web3.utils.toWei(value, 'ether');
            if (!parsedETHInput || parsedETHInput === '0') {
                setUCORNInput('');
                return
            }

            clearTimeout(inputTimeoutRef.current);
            inputTimeoutRef.current = setTimeout(async () => {
                setETHInputDisabled(true);
                setButtonLoading(true);

                try {
                    setUCORNInput(Web3.utils.fromWei(await ucornRouter.methods.quote(true, parsedETHInput).call(), 'ether'));
                } catch (e) {
                }

                setETHInputDisabled(false);
                setButtonLoading(false);
                if (web3) {
                    let chainID = await web3.eth.getChainId();
                    if (chainID === web3.utils.toBigInt(130) || chainID === web3.utils.toBigInt(1)) {
                        setButtonDisabled(false);
                    }
                }
            }, 800);
        }
    }

    async function onUCORNInputChange(value: string) {
        if (value === '') {
            setETHInput('');
            setUCORNInput('');
            setButtonDisabled(true);
            return;
        }

        const inputRegex = /^[0-9]+(\.[0-9]*)?$/;
        if (inputRegex.test(value)) setUCORNInput(value);

        const quoteRegex = /^[0-9]+(\.[0-9]+)?$/;
        if (quoteRegex.test(value)) {
            let parsedUCORNInput: string = Web3.utils.toWei(value, 'ether');
            if (!parsedUCORNInput || parsedUCORNInput === '0') {
                setETHInput('');
                return
            }

            clearTimeout(inputTimeoutRef.current);
            inputTimeoutRef.current = setTimeout(async () => {
                setUCORNInputDisabled(true);
                setButtonLoading(true);

                try {
                    setETHInput(Web3.utils.fromWei(await ucornRouter.methods.quote(false, parsedUCORNInput).call(), 'ether'));
                } catch (e) {
                }

                setUCORNInputDisabled(false);
                setButtonLoading(false);
                if (web3) {
                    let chainID = await web3.eth.getChainId();
                    if (chainID === web3.utils.toBigInt(130) || chainID === web3.utils.toBigInt(1)) {
                        setButtonDisabled(false);
                    }
                }
            }, 800);
        }
    }

    async function handleSetUseUnichainETH() {
        setUseUnichainETH(!useUnichainETH);

        if (!web3) return;
        let chainID = await web3.eth.getChainId();
        if (chainID !== web3.utils.toBigInt(130) && chainID !== web3.utils.toBigInt(1)) {
            return
        }

        let accounts = await web3.eth.getAccounts()
        if (accounts.length) {
            setAccountETHBalance('Balance: Loading...');
            let ethBalance;
            try {
                let usingWeb3 = useUnichainETH ? web3InternalL1 : web3InternalUnichain;
                ethBalance = web3.utils.fromWei(await usingWeb3.eth.getBalance(accounts[0]), 'ether');
            } catch (e) {
            }
            if (ethBalance) {
                let decimalIndex = ethBalance.indexOf('.');
                if (decimalIndex !== -1) {
                    ethBalance = ethBalance.substring(0, decimalIndex + 7);
                }
            } else {
                ethBalance = 'ERROR';
            }

            setAccountETHBalance('Balance: ' + ethBalance);
        }
    }

    const [slippage, setSlippage] = useState('20');
    const [slippageDisabled, setSlippageDisabled] = useState(false);

    async function onSlippageChange(value: string) {
        if (value === '') {
            setSlippage('20');
            return;
        }
        if (Number(value) > 49) {
            setSlippage('49');
            return;
        }

        setSlippage(value);
    }

    async function handleButton() {
        if (!web3) {
            return;
        }

        let accounts = await web3.eth.getAccounts()
        if (accounts.length) {
            if (isBuying) {
                let parsedETHInput: string = Web3.utils.toWei(ethInput, 'ether');
                if (!parsedETHInput || parsedETHInput === '0') return;

                let parsedUCORNInput: string = Web3.utils.toWei(ucornInput, 'ether');
                if (!parsedUCORNInput || parsedUCORNInput === '0') return;
                let amountOutMin = web3.utils.toBigInt(parsedUCORNInput) * web3.utils.toBigInt(String(100 - Number(slippage))) / web3.utils.toBigInt(100);
                if (amountOutMin === web3.utils.toBigInt(0)) return;

                setETHInputDisabled(true);
                setSlippageDisabled(true);
                setButtonLoading(true);

                let chainID = await web3.eth.getChainId();
                if (chainID !== web3.utils.toBigInt(130) && chainID !== web3.utils.toBigInt(1)) {
                    setETHInputDisabled(false);
                    setSlippageDisabled(false);
                    setButtonLoading(false);
                    return;
                }

                let gasLimit;
                try {
                    if (chainID === web3.utils.toBigInt(130)) {
                        gasLimit = await ucornRouter.methods.ucorn(amountOutMin, accounts[0]).estimateGas(
                            {
                                from: accounts[0],
                                value: parsedETHInput,
                            }
                        )
                        gasLimit = gasLimit + (gasLimit / web3.utils.toBigInt(5));
                    } else {
                        gasLimit = await bridge.methods.depositTransaction(ucornRouterAddress, parsedETHInput, 1000000, false, ucornRouter.methods.ucorn(amountOutMin, accounts[0]).encodeABI()).estimateGas(
                            {
                                from: accounts[0],
                                value: useUnichainETH ? '' : parsedETHInput,
                            }
                        )
                        gasLimit = gasLimit + (gasLimit / web3.utils.toBigInt(5));
                    }
                } catch (e) {
                    setModalTitle('⚠️ Uh-oh!');
                    setModalContent('Failed to estimate gas: ' + (e as Error).message);
                    setModalOpen(true);

                    setETHInputDisabled(false);
                    setSlippageDisabled(false);
                    setButtonLoading(false);
                    return;
                }

                try {
                    let txHash;
                    if (chainID === web3.utils.toBigInt(130)) {
                        txHash = await web3?.currentProvider?.request(
                            {
                                method: 'eth_sendTransaction',
                                params: [
                                    {
                                        from: accounts[0],
                                        gas: Web3.utils.numberToHex(String(gasLimit)),
                                        to: ucornRouterAddress,
                                        value: Web3.utils.numberToHex(parsedETHInput),
                                        data: ucornRouter.methods.ucorn(amountOutMin, accounts[0]).encodeABI(),
                                    }
                                ]
                            }
                        )
                    } else {
                        txHash = await web3?.currentProvider?.request(
                            {
                                method: 'eth_sendTransaction',
                                params: [
                                    {
                                        from: accounts[0],
                                        gas: Web3.utils.numberToHex(String(gasLimit)),
                                        to: bridgeAddress,
                                        value: useUnichainETH ? '' : Web3.utils.numberToHex(parsedETHInput),
                                        data: bridge.methods.depositTransaction(ucornRouterAddress, parsedETHInput, 1000000, false, ucornRouter.methods.ucorn(amountOutMin, accounts[0]).encodeABI()).encodeABI(),
                                    }
                                ]
                            }
                        )
                    }

                    let txReceipt;
                    for (let i = 0; i < 30; i++) {
                        try {
                            txReceipt = await web3.eth.getTransactionReceipt(txHash?.toString() as Bytes);
                            if (txReceipt.status === web3.utils.toBigInt(1)) {
                                setModalTitle('🎉 Congratulations!!!');
                                setModalContent('You just bought $UCORN🦄 successfully!!!');
                                setModalOpen(true);
                            } else {
                                setModalTitle('⚠️ Uh-oh!');
                                setModalContent('Your transaction executed failed. Maybe you should increase the slippage try again.');
                                setModalOpen(true);
                            }

                            break;
                        } catch (e) {
                            await new Promise(resolve => setTimeout(resolve, 1000));
                        }
                    }
                    if (!txReceipt) {
                        setModalTitle('⚠️ Uh-oh!');
                        setModalContent('Your transaction has been not mined yet after 30s. Maybe you should increase the gasPrice try again.');
                        setModalOpen(true);
                    }
                } catch (e) {
                    setModalTitle('⚠️ Uh-oh!');
                    setModalContent('Failed to send your transaction: ' + (e as Error).message);
                    setModalOpen(true);
                }
            } else {
                let parsedUCORNInput: string = Web3.utils.toWei(ucornInput, 'ether');
                if (!parsedUCORNInput || parsedUCORNInput === '0') return;

                let parsedETHInput: string = Web3.utils.toWei(ethInput, 'ether');
                if (!parsedETHInput || parsedETHInput === '0') return;
                let amountOutMin = web3.utils.toBigInt(parsedETHInput) * web3.utils.toBigInt(String(100 - Number(slippage))) / web3.utils.toBigInt(100);
                if (amountOutMin === web3.utils.toBigInt(0)) return;

                setETHInputDisabled(true);
                setSlippageDisabled(true);
                setButtonLoading(true);

                let chainID = await web3.eth.getChainId();
                if (chainID !== web3.utils.toBigInt(130) && chainID !== web3.utils.toBigInt(1)) {
                    setETHInputDisabled(false);
                    setSlippageDisabled(false);
                    setButtonLoading(false);
                    return;
                }

                {
                    let gasLimit;
                    try {
                        if (chainID === web3.utils.toBigInt(130)) {
                            gasLimit = await ucorn.methods.approve(ucornRouterAddress, parsedUCORNInput).estimateGas(
                                {
                                    from: accounts[0]
                                }
                            )
                            gasLimit = gasLimit + (gasLimit / web3.utils.toBigInt(5));
                        } else {
                            gasLimit = await bridge.methods.depositTransaction(ucornAddress, 0, 1000000, false, ucorn.methods.approve(ucornRouterAddress, parsedUCORNInput).encodeABI()).estimateGas(
                                {
                                    from: accounts[0]
                                }
                            )
                            gasLimit = gasLimit + (gasLimit / web3.utils.toBigInt(5));
                        }
                    } catch (e) {
                        setModalTitle('⚠️ Uh-oh!');
                        setModalContent('Failed to estimate gas: ' + (e as Error).message);
                        setModalOpen(true);

                        setETHInputDisabled(false);
                        setSlippageDisabled(false);
                        setButtonLoading(false);
                        return;
                    }

                    try {
                        let txHash;
                        if (chainID === web3.utils.toBigInt(130)) {
                            txHash = await web3?.currentProvider?.request(
                                {
                                    method: 'eth_sendTransaction',
                                    params: [
                                        {
                                            from: accounts[0],
                                            gas: Web3.utils.numberToHex(String(gasLimit)),
                                            to: ucornAddress,
                                            data: ucorn.methods.approve(ucornRouterAddress, parsedUCORNInput).encodeABI(),
                                        }
                                    ]
                                }
                            )
                        } else {
                            txHash = await web3?.currentProvider?.request(
                                {
                                    method: 'eth_sendTransaction',
                                    params: [
                                        {
                                            from: accounts[0],
                                            gas: Web3.utils.numberToHex(String(gasLimit)),
                                            to: bridgeAddress,
                                            data: bridge.methods.depositTransaction(ucornAddress, 0, 1000000, false, ucorn.methods.approve(ucornRouterAddress, parsedUCORNInput).encodeABI()).encodeABI(),
                                        }
                                    ]
                                }
                            )
                        }

                        let txReceipt;
                        for (let i = 0; i < 30; i++) {
                            try {
                                txReceipt = await web3.eth.getTransactionReceipt(txHash?.toString() as Bytes);
                                if (txReceipt.status === web3.utils.toBigInt(1)) {
                                    break
                                } else {
                                    setModalTitle('⚠️ Uh-oh!');
                                    setModalContent('Your approve transaction executed failed. You can try again later.');
                                    setModalOpen(true);
                                    return;
                                }
                            } catch (e) {
                                await new Promise(resolve => setTimeout(resolve, 1000));
                            }
                        }
                        if (!txReceipt) {
                            setModalTitle('⚠️ Uh-oh!');
                            setModalContent('Your approve transaction has been not mined yet after 30s. Maybe you should increase the gasPrice try again.');
                            setModalOpen(true);

                            setETHInputDisabled(false);
                            setSlippageDisabled(false);
                            setButtonLoading(false);
                            return;
                        }
                    } catch (e) {
                        setModalTitle('⚠️ Uh-oh!');
                        setModalContent('Failed to send your approve transaction: ' + (e as Error).message);
                        setModalOpen(true);

                        setETHInputDisabled(false);
                        setSlippageDisabled(false);
                        setButtonLoading(false);
                        return;
                    }
                }

                {
                    let gasLimit;
                    try {
                        if (chainID === web3.utils.toBigInt(130)) {
                            gasLimit = await ucornRouter.methods.abandon(parsedUCORNInput, amountOutMin, accounts[0]).estimateGas(
                                {
                                    from: accounts[0],
                                }
                            )
                            gasLimit = gasLimit + (gasLimit / web3.utils.toBigInt(5));
                        } else {
                            gasLimit = await bridge.methods.depositTransaction(ucornRouterAddress, parsedETHInput, 1000000, false, ucornRouter.methods.abandon(parsedUCORNInput, amountOutMin, accounts[0]).encodeABI()).estimateGas(
                                {
                                    from: accounts[0],
                                }
                            )
                            gasLimit = gasLimit + (gasLimit / web3.utils.toBigInt(5));
                        }
                    } catch (e) {
                        setModalTitle('⚠️ Uh-oh!');
                        setModalContent('Failed to estimate gas: ' + (e as Error).message);
                        setModalOpen(true);

                        setETHInputDisabled(false);
                        setSlippageDisabled(false);
                        setButtonLoading(false);
                        return;
                    }

                    try {
                        let txHash;
                        if (chainID === web3.utils.toBigInt(130)) {
                            txHash = await web3?.currentProvider?.request(
                                {
                                    method: 'eth_sendTransaction',
                                    params: [
                                        {
                                            from: accounts[0],
                                            gas: Web3.utils.numberToHex(String(gasLimit)),
                                            to: ucornRouterAddress,
                                            data: ucornRouter.methods.abandon(parsedUCORNInput, amountOutMin, accounts[0]).encodeABI(),
                                        }
                                    ]
                                }
                            )
                        } else {
                            txHash = await web3?.currentProvider?.request(
                                {
                                    method: 'eth_sendTransaction',
                                    params: [
                                        {
                                            from: accounts[0],
                                            gas: Web3.utils.numberToHex(String(gasLimit)),
                                            to: bridgeAddress,
                                            data: bridge.methods.depositTransaction(ucornRouterAddress, 0, 1000000, false, ucornRouter.methods.abandon(parsedUCORNInput, amountOutMin, accounts[0]).encodeABI()).encodeABI(),
                                        }
                                    ]
                                }
                            )
                        }

                        let txReceipt;
                        for (let i = 0; i < 30; i++) {
                            try {
                                txReceipt = await web3.eth.getTransactionReceipt(txHash?.toString() as Bytes);
                                if (txReceipt.status === web3.utils.toBigInt(1)) {
                                    setModalTitle('🎉 Sold!');
                                    setModalContent('You sold your $UCORN successfully!');
                                    setModalOpen(true);
                                } else {
                                    setModalTitle('⚠️ Uh-oh!');
                                    setModalContent('Your sell transaction executed failed. Maybe you should increase the slippage try again.');
                                    setModalOpen(true);
                                }

                                break;
                            } catch (e) {
                                await new Promise(resolve => setTimeout(resolve, 1000));
                            }
                        }
                        if (!txReceipt) {
                            setModalTitle('⚠️ Uh-oh!');
                            setModalContent('Your sell transaction has been not mined yet after 30s. Maybe you should increase the gasPrice try again.');
                            setModalOpen(true);

                            setETHInputDisabled(false);
                            setSlippageDisabled(false);
                            setButtonLoading(false);
                            return;
                        }
                    } catch (e) {
                        setModalTitle('⚠️ Uh-oh!');
                        setModalContent('Failed to send your sell transaction: ' + (e as Error).message);
                        setModalOpen(true);

                        setETHInputDisabled(false);
                        setSlippageDisabled(false);
                        setButtonLoading(false);
                        return;
                    }
                }
            }

            setETHInputDisabled(false);
            setSlippageDisabled(false);
            setButtonLoading(false);
        } else {
            setButtonLoading(true);

            try {
                await web3.currentProvider?.request({method: 'eth_requestAccounts'});
                await handleUpdate();
            } catch (e) {
            }

            setButtonLoading(false);
        }
    }

    return (
        <CssVarsProvider disableTransitionOnChange>
            <CssBaseline/>
            <GlobalStyles
                styles={{}}
            />

            <Modal
                aria-labelledby='modal-title'
                aria-describedby='modal-desc'
                open={modalOpen}
                onClose={(_event, reason) => {
                    if (reason === 'backdropClick') return;
                    setModalOpen(false);
                }}

                sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
            >
                <Sheet
                    variant='outlined'
                    sx={{maxWidth: 500, borderRadius: 'md', p: 3, boxShadow: 'lg'}}
                >
                    <ModalClose variant='plain' sx={{m: 1}}/>
                    <Typography
                        component='h2'
                        id='modal-title'
                        level='h3'
                        textColor='inherit'
                        sx={{fontWeight: 'lg', mb: 2, userSelect: 'none'}}
                    >
                        {modalTitle}
                    </Typography>

                    <Typography id='modal-desc' textColor='text.tertiary' style={{whiteSpace: 'pre-wrap'}}
                                sx={{fontWeight: 'md'}}>
                        {modalContent}
                    </Typography>
                </Sheet>
            </Modal>

            <Box
                sx={
                    () => ({
                        width: {xs: '100%', md: '50vw'},
                        transition: 'width var(--Transition-duration)',
                        transitionDelay: 'calc(var(--Transition-duration) + 0.1s)',
                        position: 'relative',
                        zIndex: 1,
                        display: 'flex',
                        justifyContent: 'flex-end',
                        backdropFilter: 'blur(128px)',
                        backgroundImage: `url("./backgroundBlur.png")`
                    })}
            >

                <Box
                    sx={{
                        flexDirection: 'column',
                        minHeight: '100dvh',
                        width: '100%',
                        px: 2,
                    }}
                >

                    <Typography sx={{
                        marginLeft: 2,
                        paddingTop: 6,
                        paddingBottom: 2,
                        userSelect: 'none'
                    }}
                                level='h2'>$UCORN🦄</Typography>
                    <Typography sx={{
                        marginLeft: 2,
                        paddingBottom: 3,
                        userSelect: 'none',
                    }} level='title-lg'>The first token on Uniswap V4 🦄🦄🦄🦄</Typography>
                    <Typography
                        sx={{
                            fontFamily: 'Courier New',
                            marginLeft: 2,
                            wordBreak: 'break-word',
                            width: '94%',
                            textShadow: '2px 2px 2px rgba(0, 0, 0, 0.15)',
                        }}
                        level='body-xs'
                    >

                        <b style={{userSelect: 'none'}}>Uniswap V4&nbsp;&nbsp;: </b><a
                        style={{color: 'black', textDecoration: 'underline', textDecorationColor: '#808080'}}
                        target='_blank' rel="noreferrer noopener"
                        href='https://unichainexplorer.chaineye.tools/address/0x1F98400000000000000000000000000000000004'>0x1F98400000000000000000000000000000000004</a><br
                        style={{userSelect: 'none'}}/>

                        <b style={{userSelect: 'none'}}>UCORN&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: </b><a
                        style={{color: 'black', textDecoration: 'underline', textDecorationColor: '#808080'}}
                        target='_blank' rel="noreferrer noopener"
                        href='https://unichainexplorer.chaineye.tools/token/0x0000000000c82e1318ebb48e7AbA43Be281A3B8d'>0x0000000000c82e1318ebb48e7AbA43Be281A3B8d</a><br
                        style={{userSelect: 'none'}}/>

                        <b style={{userSelect: 'none'}}>URouter&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: </b><a
                        style={{color: 'black', textDecoration: 'underline', textDecorationColor: '#808080'}}
                        target='_blank' rel="noreferrer noopener"
                        href='https://unichainexplorer.chaineye.tools/address/0x0000000000EBCF4bAca7e81ca2d3ec09DF339c22'>0x0000000000EBCF4bAca7e81ca2d3ec09DF339c22</a><span
                        style={{userSelect: 'none', color: 'black'}}> (Only for $UCORN🦄)</span><br
                        style={{userSelect: 'none'}}/>

                        <b style={{userSelect: 'none'}}>Pool ID&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: </b><a
                        style={{color: 'black', textDecoration: 'underline', textDecorationColor: '#808080'}}
                        target='_blank' rel="noreferrer noopener"
                        href='https://unichainexplorer.chaineye.tools/token/0x4529A01c7A0410167c5740C487A8DE60232617bf/instance/2'>0x9d4e5f6d6bcef37d79c1cb4a048c68cb31bccca03618096512612c73dcb82d3f</a><br
                        style={{userSelect: 'none'}}/>

                        <b style={{userSelect: 'none'}}>Currency&nbsp;&nbsp;&nbsp;&nbsp;: </b><span
                        style={{
                            userSelect: 'none',
                            color: 'black'
                        }}>ETH (New feature of Uniswap V4!!! Not WETH!!!)</span><br
                        style={{userSelect: 'none'}}/>

                        <b style={{userSelect: 'none'}}>Fee&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: </b><span
                        style={{userSelect: 'none', color: 'black'}}>1% (=10000 in ABI)</span><br
                        style={{userSelect: 'none'}}/>

                        <b style={{userSelect: 'none'}}>TickSpacing&nbsp;: </b><span
                        style={{userSelect: 'none', color: 'black'}}>60</span><br style={{userSelect: 'none'}}/>

                        <b style={{userSelect: 'none'}}>Hooks&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: </b><span
                        style={{userSelect: 'none', color: 'black'}}>N/A</span><br style={{userSelect: 'none'}}/>
                    </Typography>


                    <Box
                        component='main'
                        sx={{
                            my: 'auto',
                            pt: 10,
                            pb: 5,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2.5,
                            width: 400,
                            maxWidth: '100%',
                            mx: 'auto',
                            borderRadius: 'sm',
                            '& form': {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2,
                            },
                            [`& .MuiFormLabel-asterisk`]: {
                                visibility: 'hidden',
                            },
                        }}
                    >
                        <Stack sx={{gap: 4, mb: 1}}>
                            <Stack sx={{gap: 1}}>
                                <Typography
                                    sx={{paddingBottom: 1, userSelect: 'none'}}
                                    level='h3'
                                >
                                    Swap $UCORN🦄
                                </Typography>

                                <Typography
                                    sx={{paddingBottom: 0, userSelect: 'none'}}
                                    level='body-xs'
                                >
                                    When Uniswap V4 goes live officially, you can trade $UCORN🦄 at Uniswap frontend
                                    immediately.
                                </Typography>
                            </Stack>
                        </Stack>

                        <Divider
                            sx={(theme) => ({
                                [theme.getColorSchemeSelector('light')]: {
                                    color: {xs: '#FFF', md: 'text.tertiary'},
                                },
                            })}
                        >
                        </Divider>

                        {isBuying ? (
                            <>
                                <FormControl>
                                    <div style={{display: 'grid', gridTemplateColumns: '1fr auto', gap: '16px'}}>
                                        <FormLabel>ETH</FormLabel>
                                        <FormLabel style={{gridColumn: '2'}}>{accountETHBalance}</FormLabel>
                                    </div>
                                    <Input
                                        onChange={(e) => onETHInputChange(e.target.value)}
                                        value={ethInput}
                                        endDecorator={
                                            <Typography sx={{userSelect: 'none'}}>ETH</Typography>
                                        }
                                        placeholder='0.0'
                                        disabled={ethInputDisabled}
                                    />
                                </FormControl>

                                {onL1 && (
                                    <Typography level='body-xs'
                                                sx={{
                                                    justifyContent: "right",
                                                }}
                                                endDecorator={
                                                    <Switch sx={{ml: 1}} checked={useUnichainETH}
                                                            onClick={handleSetUseUnichainETH}/>
                                                }
                                    >
                                        Use Unichain ETH
                                    </Typography>
                                )}

                                <Stack
                                    sx={{
                                        mt: 1,
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <IconButton
                                        onClick={handleSetIsSelling}
                                        sx={{
                                            borderRadius: '50%',
                                            backgroundColor: 'pink',
                                            '&:hover': {backgroundColor: 'lightpink'},
                                        }}
                                    >
                                        <SwapVert sx={{fontSize: 24}}/>
                                    </IconButton>
                                </Stack>

                                <FormControl>
                                    <div style={{display: 'grid', gridTemplateColumns: '1fr auto', gap: '16px'}}>
                                        <FormLabel>$UCORN🦄</FormLabel>
                                        <FormLabel style={{gridColumn: '2'}}>{accountUCORNBalance}</FormLabel>
                                    </div>
                                    <Input
                                        value={ucornInput}
                                        endDecorator={
                                            <Typography sx={{userSelect: 'none'}}>$UCORN🦄</Typography>
                                        }
                                        placeholder='0.0'
                                        disabled={ucornInputDisabled}
                                    />
                                </FormControl>
                            </>
                        ) : (
                            <>
                                <FormControl>
                                    <div style={{display: 'grid', gridTemplateColumns: '1fr auto', gap: '16px'}}>
                                        <FormLabel>$UCORN🦄</FormLabel>
                                        <FormLabel style={{gridColumn: '2'}}>{accountUCORNBalance}</FormLabel>
                                    </div>
                                    <Input
                                        onChange={(e) => onUCORNInputChange(e.target.value)}
                                        value={ucornInput}
                                        endDecorator={
                                            <Typography sx={{userSelect: 'none'}}>$UCORN🦄</Typography>
                                        }
                                        placeholder='0.0'
                                        disabled={ucornInputDisabled}
                                    />
                                </FormControl>

                                <Stack
                                    sx={{
                                        mt: 1,
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <IconButton
                                        onClick={handleSetIsSelling}
                                        sx={{
                                            borderRadius: '50%',
                                            backgroundColor: 'pink',
                                            '&:hover': {backgroundColor: 'lightpink'},
                                        }}
                                    >
                                        <SwapVert sx={{fontSize: 24}}/>
                                    </IconButton>
                                </Stack>

                                <FormControl>
                                    <div style={{display: 'grid', gridTemplateColumns: '1fr auto', gap: '16px'}}>
                                        <FormLabel>ETH</FormLabel>
                                        <FormLabel style={{gridColumn: '2'}}>{accountETHBalance}</FormLabel>
                                    </div>
                                    <Input
                                        onChange={(e) => onETHInputChange(e.target.value)}
                                        value={ethInput}
                                        endDecorator={
                                            <Typography sx={{userSelect: 'none'}}>ETH</Typography>
                                        }
                                        placeholder='0.0'
                                        disabled={ethInputDisabled}
                                    />
                                </FormControl>
                            </>
                        )}


                        <FormControl>
                            <FormLabel>Slippage</FormLabel>
                            <Input
                                onChange={(e) => onSlippageChange(e.target.value)}
                                value={slippage}
                                endDecorator={
                                    <Typography sx={{userSelect: 'none'}}>%</Typography>
                                }
                                placeholder='20'
                                disabled={slippageDisabled}
                            />
                        </FormControl>

                        <Typography
                            sx={{marginTop: 0, userSelect: 'none'}}
                            level='body-xs'
                        >
                            Please make sure your Unichain RPC is available to send transaction or you need to swap
                            $UCORN🦄 from
                            L1.
                        </Typography>

                        {showSwitchNetwork && (
                            <Box
                                display="flex"
                                gap={2}
                                justifyContent="space-between"
                                sx={{
                                    visibility: showSwitchNetwork ? 'visible' : 'hidden',
                                }}
                            >
                                <Button
                                    sx={{flexGrow: 1, flexBasis: 0}}
                                    onClick={switchToL1}
                                >
                                    Switch to L1
                                </Button>

                                <Button
                                    sx={{flexGrow: 1, flexBasis: 0}}
                                    onClick={switchToUnichain}
                                >
                                    Switch to Unichain
                                </Button>
                            </Box>
                        )}

                        {!showSwitchNetwork && (
                            <>
                                <Button
                                    sx={{marginTop: 0}}
                                    loading={buttonLoading}
                                    disabled={buttonDisabled}
                                    onClick={handleButton}
                                >
                                    {buttonContent}
                                </Button>
                            </>
                        )}

                        <Box component='footer' sx={{pt: 2}}>
                            <Typography
                                level='body-xs'
                                sx={{
                                    textAlign: 'center',
                                    userSelect: 'none'
                                }}
                                component="a"
                                href="https://x.com/UCORN_Unichain"
                                target="_blank"
                                rel="noreferrer noopener"
                            >
                                $UCORN🦄
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>

            <Box
                sx={() => ({
                    height: '100%',
                    position: 'fixed',
                    right: 0,
                    top: 0,
                    bottom: 0,
                    left: {xs: 0, md: '50vw'},
                    transition: 'background-image var(--Transition-duration), left var(--Transition-duration) !important',
                    transitionDelay: 'calc(var(--Transition-duration) + 0.1s)',
                    backgroundColor: 'background.level1',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundImage: `url("./background.jpg")`
                })}
            />


        </CssVarsProvider>
    )
        ;
}